import Globalize from 'globalize';
import moment from 'moment';
import Personalizer from 'personalizer';
import i18next from 'i18next';

i18next.loadNamespaces(['common']);

var CLIENT_SERVER_TIME_OFFSET = 0;

var DaysOfWeek = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
};

var MinWeekdayKeys = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];

var DateUtil = {
    /**
     *
     * @deprecated Use DateFormatter.js instead.
     */
    toISODateString: function(date) {
        var month = 1 + date.getMonth();
        var day = date.getDate();
        var year = date.getFullYear();

        return year + '-' + this.pad2(month) + '-' + this.pad2(day);
    },

    /**
     * This function should only be used for creating throwaway date objects, such as to display a date to the user using
     * reusable date display formatting functions. It creates objects with UTC hours, minutes, etc. but in the BROWSER's time zone.
     * This means that these can NOT be safely passed to a service or persisted anywhere as the epoch milliseconds time backing the
     * Date object is nonsense.
     */
    toUTCDate: function(date) {
        return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );
    },

    pad2: function(val) {
        var str = '' + val;
        if (str.length >= 2) {
            return str;
        } else if (str.length == 1) {
            return '0' + str;
        } else {
            return '00';
        }
    },

    /***
     *
     * @deprecated Use DateParser.js instead.
     */
    getDateFromISODateString: function(dateString) {
        var year = dateString.substring(0, 4);
        var month = +dateString.substring(5, 7) - 1;
        var day = dateString.substring(8, 10);
        return new Date(year, month, day);
    },

    /**
     * parse timestamps in the format YYYY-MM-DDTHH:mm:ss.SSS (aka ConnectTimestamp)
     * @deprecated Use DateParser.js instead.
     */
    getDateFromISOTimestampString: function(timestampString) {
        var year = timestampString.substring(0, 4);
        var month = +timestampString.substring(5, 7) - 1;
        var day = +timestampString.substring(8, 10);
        var hour = +timestampString.substring(11, 13);
        var minute = +timestampString.substring(14, 16);
        var second = +timestampString.substring(17, 19);
        var millisecond = +timestampString.substring(20);
        return new Date(Date.UTC(year, month, day, hour, minute, second, millisecond));
    },

    /***
     *
     * @deprecated Use DateParser.js instead.
     */
    parseDateFromISOTimestampString: function(timestampString) {
        var year = timestampString.substring(0, 4);
        var month = +timestampString.substring(5, 7) - 1;
        var day = +timestampString.substring(8, 10);
        var hour = +timestampString.substring(11, 13);
        var minute = +timestampString.substring(14, 16);
        var second = +timestampString.substring(17, 19);
        var millisecond = +timestampString.substring(20);
        return new Date(year, month, day, hour, minute, second, millisecond);
    },

    addMonth: function(date) {
        var month = date.getMonth();
        month++;
        date.setMonth(month);
        if (date.getMonth() > month) {
            //adding month rolled more than one month up
            //setting date to 0, sets to the last day of the previous month
            date.setDate(0);
        }
        return date;
    },
    subtractMonth: function(date) {
        var month = date.getMonth();
        month--;
        date.setMonth(month);
        if (date.getMonth > month) {
            date.setDate(0);
        }
        return date;
    },

    /**
     *
     * @deprecated Use DateParser.js instead.
     */
    formatTime: function(date, timeFormat24Hour) {
        var time;
        if (timeFormat24Hour) {
            var hour = this.pad2(date.getHours());
            var minutes = this.pad2(date.getMinutes());
            time = hour + ':' + minutes;
        } else {
            var hour24 = date.getHours();
            var hour;
            var amPm;

            if (hour24 == 0 || hour24 == 12) {
                hour = 12;
                amPm = hour24 == 0 ? 'AM' : 'PM';
            } else {
                hour = hour24 % 12;
                amPm = hour24 > 12 ? 'PM' : 'AM';
            }

            var minutes = this.pad2(date.getMinutes());

            time = hour + ':' + minutes + ' ' + amPm;
        }
        return time;
    },

    /**
     *
     * @deprecated Use DateParser.js instead.
     */
    howLongAgo: function(timeLocal) {
        var _localTime = timeLocal;
        if (typeof _localTime == 'String') {
            _localTime = Globalize.parseDate(_localTime, 'yyyy-MM-dd HH:mm:ss');
        }

        // Add a member for number of days ago.
        var elapsedMilliseconds = new Date().getTime() - _localTime;
        var agoValue = '';
        var agoKey = '';
        if (elapsedMilliseconds < 3600000) {
            agoValue = Math.floor(elapsedMilliseconds / 60000);
            if (agoValue > 1) {
                agoKey = 'mins_ago';
            } else if (agoValue <= 0) {
                agoValue = '';
                agoKey = 'just_now';
            } else {
                agoKey = 'min_ago';
            }
        } else if (elapsedMilliseconds < 86400000) {
            agoValue = Math.floor(elapsedMilliseconds / 3600000);
            if (agoValue > 1) {
                agoKey = 'hours_ago';
            } else {
                agoKey = 'hour_ago';
            }
        } else {
            agoValue = Math.floor(elapsedMilliseconds / 86400000);
            if (agoValue > 1) {
                agoKey = 'days_ago';
            } else {
                agoValue = '';
                agoKey = 'yesterday';
            }
        }
        return i18next.t(`common:${agoKey}`, agoValue);
    },

    /**
     * This function returns a new date object that represents the time as of the last sunday at 12:00 am. This
     * is the start of the week for some business requirements. Note that this function does not take in consideration
     * the start of the week based on the user's culture or user preferences.
     */
    getStartOfWeek: function() {
        return moment()
            .day(0)
            .toDate();
    },

    getEndOfWeek: function() {
        var endOfWeek = moment()
            .day(0)
            .toDate();
        endOfWeek.setDate(endOfWeek.getDate() + 7);
        return endOfWeek;
    },

    /**
     * Returns whether this daily summary contains data for today
     */
    isToday: function(dateObj) {
        var now = DateUtil.getCurrentTime();
        return (
            now.getFullYear() == dateObj.getFullYear() &&
            now.getMonth() == dateObj.getMonth() &&
            now.getDate() == dateObj.getDate()
        );
    },

    isPastDay: function(calendarDate) {
        let startOfToday = moment(new Date()).startOf('day');
        return moment(calendarDate).isBefore(startOfToday);
    },

    isFutureDay: function(calendarDate) {
        let endOfToday = moment(new Date()).endOf('day');
        return moment(calendarDate).isAfter(endOfToday);
    },

    /**
     * This sets the current known time in the system. This stores an offset between the user's clock and
     * the time on the server.  This is to help mitigate issues with time being wrong in the user's browser. This
     * is not fool proof and isn't intended to be. Latency will impact the accuracy as well as changing the users
     * computer time.  The system time needs to be set as soon as possible, preferably in the loading process.
     *
     * @param systemTime the system time of the server.
     */
    setSystemTime: function(systemTime) {
        CLIENT_SERVER_TIME_OFFSET = new Date().getTime() - systemTime;
    },

    getCurrentTime: function() {
        var newDate = new Date(new Date().getTime() - CLIENT_SERVER_TIME_OFFSET);
        return newDate;
    },

    getTimeUsingTimeZoneOffSet: function(date, offset) {
        var utc = date.getTime() + date.getTimezoneOffset() * 60000;
        // create new Date object using supplied offset
        var newDate = new Date(utc + 3600000 * offset);
        return newDate;
    },

    /**
     * The purpose of this function is to generate a time with the given time information specified with a timezone. The
     * time provided is expected to be local to the time at the timezone (offset) provided. For example, if you wanted
     * to get the time in GMT for 8am, march 5, 2015 in california (-8:00), you would pass in 2015, 2, 5, 8, 0, 0, -8)
     * and it would return a date that internally represents that time in GMT.
     *
     *
     * @param year
     * @param month
     * @param day
     * @param hour
     * @param minute note this is 0 based!
     * @param second
     * @param ms
     * @param offsetHours The offset in hours.
     * @returns Date object which will have an internal time specified in UTC. Note that formatting functions will
     * still consider this time to be local to the PC, so don't be fooled by this.
     */
    createDateUsingTimeZoneOffSet: function(year, month, day, hour, minute, second, ms, offsetHours) {
        // Javascript dates assume you are referring to local time, so localDate will be the given time local to
        // the browser.
        var localDate = new Date(year, month, day, hour, minute, second, ms);

        // The actual offset we use will be the difference between the browser's offset and the selected offset.
        var localDateOffsetMinutes = -localDate.getTimezoneOffset();
        var desiredOffsetMinutes = offsetHours * 60;
        var offsetDifference = localDateOffsetMinutes - desiredOffsetMinutes;

        // We calculate the time in ticks for our actual GMT time.
        var utcDate = new Date(localDate.getTime() + offsetDifference * 60000);

        return utcDate;
    },

    getHighChartsDateFormat: function(useShortYear) {
        var dateFormat = Localizer.currentDateFormatKey;
        var yearFlag = useShortYear ? '%y' : '%Y';

        switch (dateFormat) {
            case 'mmddyyyy':
                return '%m/%d/' + yearFlag;
            case 'ddmmyyyy':
                return '%d/%m/' + yearFlag;
            case 'yyyymmdd':
                return yearFlag + '/%m/%d';
        }

        return '%m/%d/' + yearFlag;
    },

    /**
     * Gets the closest dates to the testDate
     *
     * @param days - Array of dates to search through
     * @param testDate - date to compare
     * @returns {{bestPrevious: {index: *, date: *}, bestAfter: {index: *, date: *}}}
     */
    findClosest: function(days, testDate) {
        var bestPrevDate = days.length;
        var bestNextDate = days.length;

        var max_date_value = Math.abs(new Date(0, 0, 0).valueOf());

        var bestPrevDiff = max_date_value;
        var bestNextDiff = -max_date_value;

        var currDiff = 0;
        var i;

        for (i = 0; i < days.length; ++i) {
            currDiff = testDate - days[i];
            if (currDiff < 0 && currDiff > bestNextDiff) {
                // This means, that from testDate's point of view, days[i] is in the future
                // and thus by a candidate for the next date.
                bestNextDate = i;
                bestNextDiff = currDiff;
            }
            if (currDiff >= 0 && currDiff < bestPrevDiff) {
                // This means, that from testDate's point of view, days[i] is in the past or equal
                // and thus by a candidate for the previous date.
                bestPrevDate = i;
                bestPrevDiff = currDiff;
            }
        }

        return {
            bestPrevious: {
                index: bestPrevDate,
                date: days[bestPrevDate]
            },
            bestAfter: {
                index: bestNextDate,
                date: days[bestNextDate]
            }
        };
    },

    getDayNameOrDate: function(date, format) {
        // returns name of the day if the date is in the last 7 days or month/date if not.

        // Possible returned values:
        // e.g. For the last seven days: Sun, Mon, Tue, etc... (Long day name if format is not set to "short")
        // e.g. For dates further in time than seven days: 1/28, 1/29, 1/30, etc...

        var currentDate = new Date();

        var diffDays = moment(currentDate).diff(moment(date), 'days');

        if (diffDays < 7) {
            if (format) {
                return i18next.t('common:day.' + date.getDay() + '.' + format);
            }
            return i18next.t('common:day.' + date.getDay());
        } else {
            return date.getMonth() + 1 + '/' + date.getDate();
        }
    },

    addDays: function(date, days) {
        return moment(date)
            .add(days, 'days')
            .toDate();
    },

    subtractDays: function(date, days) {
        return moment(date)
            .subtract(days, 'days')
            .toDate();
    },

    isFirstDayOfMonth: function(date) {
        return date ? moment(date).get('date') === 1 : false;
    },

    /**
     * Returns the number of weeks between 2 dates.
     */
    calculateWeekDifference: function(startDate, endDate) {
        return moment(endDate).diff(moment(startDate), 'week');
    },
    calculateDaysDifference: function(startDate, endDate) {
        return moment(endDate).diff(moment(startDate), 'day');
    },

    /***
     * Returns true if date is in between (inclusive) start and end
     *
     * @param start: start date (Moment|String|Date)
     * @param date: date to test (Moment|String|Date)
     * @param end: end date (Moment|String|Date)
     */
    isBetweenDates: function(start, date, end) {
        return !(moment(date).isBefore(start) || moment(date).isAfter(end));
    },

    getFirstDateOfWeek: function(date, firstDayOfWeek) {
        var momentFirstDayOfWeek = firstDayOfWeek - 2;
        var weekStart = moment(date).day(momentFirstDayOfWeek);
        if (weekStart.isAfter(date, 'day')) {
            weekStart.add(-7, 'day');
        }

        return weekStart.toDate();
    },

    dateFormatNoLeadingZeros: function(value) {
        var result = Personalizer.personalizeDuration(value);
        var x = result.indexOf('00:');

        if (x === 0) {
            result = result.substring(3);
            x = result.indexOf('00:');
            if (x === 0) {
                result = result.substring(3);
            }
        }
        return result;
    },

    getMonthNumber: function(milliseconds) {
        let month = Number(moment(milliseconds).format('M'));

        return month < 10 ? '0' + month : month + '';
    },

    getPriorDate: function(days) {
        return moment().subtract(days, 'days'); // substract a given number of days
    }
};

DateUtil.DaysOfWeek = DaysOfWeek;
DateUtil.MinWeekdayKeys = MinWeekdayKeys;
export default DateUtil;
